import { beforeEnterMicrofrontend } from '@/router/routes/business/inventory/utils/beforeEnterMicrofrontend'

export default [
  {
    path: ':path(stock-takes.*)?',
    name: 'inventory.stock-takes',
    beforeEnter: beforeEnterMicrofrontend('stock-takes'),
    component: () => import('@/views/business/inventory/stock-takes/iframe-service.vue'),
  },
]
